import '../App.css';

import icon1 from '../assets/images/icon-1.png';
import icon2 from '../assets/images/icon-2.png';
import icon3 from '../assets/images/icon-3.png';
import icon4 from '../assets/images/icon-4.png';
import icon5 from '../assets/images/icon-5.png';
import icon6 from '../assets/images/icon-6.png';

import arrow from '../assets/images/arrow.png';

const steps = [
    {
        icon: icon1,
        title: "Travelers",
        text: "People around the world plan their trips."
    },
    {
        icon: icon2,
        title: "Book Flights",
        text: "Travelers book flights on SkyGoose."
    },
    {
        icon: icon3,
        title: "Booking Revenue",
        text: "Booking fees generate real revenue."
    },
    {
        icon: icon4,
        title: " Open Market Buybacks",
        text: "A portion of platform revenue may be used to buy back $GOOSE."
    },
    {
        icon: icon5,
        title: "Token Burns",
        text: "Purchased $GOOSE may be permanently burned, reducing circulating supply."
    },
    {
        icon: icon6,
        title: "Stronger Flock",
        text: "A stronger community attracts more travelers."
    }
];

function HowItWorks() {

    return (

        <section className="how-section" id="how">

            <div className="container">

                <div className="how-box">

                    <h2>HOW IT WORKS</h2>

                    <span className="title-line"></span>

                    <div className="how-wrapper">

                        {steps.map((step, index) => (

                            <>

                                <div className="how-item" key={index}>

                                    <img
                                        src={step.icon}
                                        className="how-icon"
                                        alt=""
                                    />

                                    <h4>
                                        <span>{index + 1}</span> {step.title}
                                    </h4>

                                    <p>{step.text}</p>

                                </div>

                                {index !== steps.length - 1 && (

                                    <img
                                        src={arrow}
                                        className="how-arrow"
                                        alt=""
                                    />

                                )}

                            </>

                        ))}

                    </div>

                </div>

            </div>

        </section>

    );

}

export default HowItWorks;